const rangeModeRecommendations = {
    ENABLE: 'enable_range_mode',
    DISABLE: 'disable_range_mode',
} as const;

export type RangeModeRecommendation = (typeof rangeModeRecommendations)[keyof typeof rangeModeRecommendations];

export default rangeModeRecommendations;
